import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { videos } from 'src/constants/videos'
import { sportIds, leagueIds, teamIds } from 'src/constants/personalizationIds'
import { promoCodes } from 'src/constants'

export default (props) => (
  <USTemplateDefault
    location={props.location}
    offerBanner={{
      title: ['Special offer for Guardians fans:', '7 days FREE + $20 off your first month'],
    }}
    offerCode={promoCodes.cleveland_guardians}
    video={videos.bally_guardians.videoUrl}
    videoMobile={videos.bally_guardians.videoMobileUrl}
    title="Watch Cleveland Guardians baseball"
    subtitle="Get live games, local team coverage & more. Regional restrictions apply."
    networkSet="baseball"
    customNetworks={['fanduelsports']}
    logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-lockup-cleveland-guardians-v2.png?w=450&ch=width&auto=format,compress"
    logoHeight="100px"
    sportId={sportIds.Baseball}
    leagueId={leagueIds.MLB}
    teamId={teamIds['Cleveland Guardians']}
  />
)
